/* =========================================
   LUMIVUE — THEME.JS
   Interactions, Cart Drawer, Accordion, etc.
   ========================================= */

document.addEventListener('DOMContentLoaded', function() {

  // ===== HEADER SCROLL =====
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // ===== MOBILE MENU =====
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ===== CART DRAWER =====
  const cartToggle = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggle.forEach(btn => btn.addEventListener('click', openCart));
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // ===== ACCORDION =====
  const accordionBtns = document.querySelectorAll('.accordion-btn');
  accordionBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const isActive = item.classList.contains('active');
      // Close all
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));
      // Open clicked if was closed
      if (!isActive) item.classList.add('active');
    });
  });

  // ===== QUANTITY SELECTOR =====
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-selector').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease' && val > 1) val--;
      if (btn.dataset.action === 'increase' && val < 99) val++;
      input.value = val;
    });
  });

  // ===== COLOR SWATCHES — met à jour l'input #product-variant-id =====
  document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const siblings = swatch.closest('.color-swatches').querySelectorAll('.swatch');
      siblings.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // FIX : met à jour le variant ID dans le formulaire
      const variantId = swatch.dataset.variantId;
      if (variantId) {
        const input = document.getElementById('product-variant-id');
        if (input) input.value = variantId;
      }
    });
  });

  // FIX : select variante (dropdown) met aussi à jour l'input hidden
  const variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const input = document.getElementById('product-variant-id');
      if (input) input.value = variantSelect.value;
    });
  }

  // ===== ACHETER MAINTENANT — ajoute au panier puis redirige =====
  const buyNowBtn = document.getElementById('buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const variantId = document.getElementById('product-variant-id')?.value;
      const quantity = document.getElementById('product-quantity')?.value || 1;

      if (!variantId) {
        alert('Veuillez sélectionner une option avant de continuer.');
        return;
      }

      buyNowBtn.textContent = 'Chargement...';
      buyNowBtn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
        });

        if (response.ok) {
          window.location.href = '/checkout';
        } else {
          const err = await response.json();
          alert(err.description || 'Une erreur est survenue. Veuillez réessayer.');
          buyNowBtn.textContent = 'Acheter maintenant →';
          buyNowBtn.disabled = false;
        }
      } catch (e) {
        alert('Une erreur est survenue. Veuillez réessayer.');
        buyNowBtn.textContent = 'Acheter maintenant →';
        buyNowBtn.disabled = false;
      }
    });
  }

  // ===== PRODUCT GALLERY THUMBS =====
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      const main = gallery.querySelector('.product-gallery-main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
      }
      gallery.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ===== ADD TO CART — AJAX =====
  const addToCartForms = document.querySelectorAll('[data-add-to-cart]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span> Ajout...';
      btn.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        if (response.ok) {
          btn.innerHTML = '✓ Ajouté au panier';
          btn.style.background = 'var(--color-accent)';
          updateCartCount();
          setTimeout(() => {
            openCart();
          }, 600);
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Erreur');
        }
      } catch (err) {
        btn.innerHTML = '✗ Erreur – réessayez';
        btn.style.background = '#c0392b';
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // ===== UPDATE CART COUNT =====
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch(e) {}
  }

  updateCartCount();

  // ===== SCROLL REVEAL =====
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal-on-scroll').forEach(el => observer.observe(el));

  // ===== SMOOTH ANNOUNCEMENT CLOSE =====
  const announcementClose = document.querySelector('[data-announcement-close]');
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.maxHeight = '0';
      announcementBar.style.overflow = 'hidden';
      announcementBar.style.transition = 'max-height 0.4s ease';
    });
  }

  // ===== CART DRAWER ITEMS RENDER =====
  async function renderCartItems() {
    const itemsContainer = document.querySelector('.cart-drawer-items');
    if (!itemsContainer) return;

    // Indicateur de chargement
    itemsContainer.innerHTML = `<div style="text-align:center;padding:2rem;color:var(--color-text-muted);">
      <span class="spinner" style="border-color:rgba(0,0,0,0.15);border-top-color:var(--color-primary);"></span>
    </div>`;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="cart-empty">
            <div class="icon">🛍️</div>
            <p>Votre panier est vide.</p>
          </div>`;
        updateCartFooter(0);
        return;
      }

      let html = '';
      cart.items.forEach(item => {
        const linePrice = ((item.price * item.quantity) / 100).toFixed(2);
        const variantInfo = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p style="font-size:0.78rem;color:var(--color-text-muted);margin:0 0 0.4rem;">${item.variant_title}</p>`
          : '';

        html += `
          <div class="cart-item" data-key="${item.key}" style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--color-border);align-items:flex-start;">

            <img src="${item.image || ''}" alt="${item.title}"
              style="width:72px;height:72px;object-fit:cover;border-radius:8px;background:var(--color-cream);flex-shrink:0;">

            <div style="flex:1;min-width:0;">
              <p style="font-weight:600;font-size:0.88rem;color:var(--color-text);margin:0 0 0.2rem;line-height:1.3;">
                ${item.product_title}
              </p>
              ${variantInfo}
              <p style="font-weight:700;font-size:0.9rem;color:var(--color-primary);margin:0 0 0.6rem;">
                ${linePrice} €
              </p>

              <!-- Contrôles quantité + suppression -->
              <div style="display:flex;align-items:center;gap:0.5rem;">
                <div style="display:flex;align-items:center;border:1px solid var(--color-border);border-radius:var(--radius-full);overflow:hidden;">
                  <button
                    onclick="cartChangeQty('${item.key}', ${item.quantity - 1})"
                    style="width:32px;height:32px;background:none;border:none;cursor:pointer;font-size:1rem;color:var(--color-text);transition:background 0.2s;"
                    onmouseover="this.style.background='var(--color-cream-dark)'"
                    onmouseout="this.style.background='none'"
                    aria-label="Diminuer la quantité">−</button>
                  <span style="width:28px;text-align:center;font-size:0.88rem;font-weight:600;">${item.quantity}</span>
                  <button
                    onclick="cartChangeQty('${item.key}', ${item.quantity + 1})"
                    style="width:32px;height:32px;background:none;border:none;cursor:pointer;font-size:1rem;color:var(--color-text);transition:background 0.2s;"
                    onmouseover="this.style.background='var(--color-cream-dark)'"
                    onmouseout="this.style.background='none'"
                    aria-label="Augmenter la quantité">+</button>
                </div>

                <button
                  onclick="cartChangeQty('${item.key}', 0)"
                  style="background:none;border:none;cursor:pointer;color:var(--color-text-muted);font-size:0.78rem;text-decoration:underline;padding:0;"
                  aria-label="Supprimer l'article">Supprimer</button>
              </div>
            </div>

          </div>`;
      });

      itemsContainer.innerHTML = html;
      updateCartFooter(cart.total_price);

    } catch(e) {
      itemsContainer.innerHTML = `<p style="text-align:center;padding:2rem;color:var(--color-text-muted);">Erreur de chargement du panier.</p>`;
    }
  }

  // Met à jour le sous-total dans le footer du drawer
  function updateCartFooter(totalPrice) {
    const subtotalEl = document.querySelector('.cart-subtotal span:last-child');
    if (subtotalEl) subtotalEl.textContent = (totalPrice / 100).toFixed(2) + ' €';
  }

  // Modifie la quantité d'un article (quantity=0 = suppression)
  window.cartChangeQty = async function(key, newQty) {
    // Désactive visuellement le drawer pendant la mise à jour
    const itemsContainer = document.querySelector('.cart-drawer-items');
    if (itemsContainer) itemsContainer.style.opacity = '0.5';

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, newQty) })
      });
      await updateCartCount();
      await renderCartItems();
    } catch(e) {
      if (itemsContainer) itemsContainer.style.opacity = '1';
    }
  };

  // Garde la compatibilité avec l'ancien nom si utilisé ailleurs
  window.removeCartItem = (key) => window.cartChangeQty(key, 0);

  cartToggle.forEach(btn => {
    btn.addEventListener('click', renderCartItems);
  });

});
